//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MainApi } from '@/api'
export default {
  name: 'xxxxxxxx',
  components: {
    //	xxxxxxxx
  },
  props: {
    tag: {
      default: '谨慎型',
    },
    id: {
      default: '',
    },
  },
  data() {
    return {
      // tagArr: ['谨慎型', '稳健型', '平衡型', '进取型', '激进型'],
      // tag: '',
      loading: true,
    }
  },
  created() {},
  mounted() {
    this.inPageFn()
  },
  methods: {
    changeCloseFn() {
      if (this.id) {
        this.$vux.loading.show({
          text: '计算中',
        })

        MainApi.getUserDepositPlanCompute({
          id: this.id,
        })
          .then(data => {
            if (data.Status === 200) {
              this.$vux.loading.hide()
              this.$router.push({
                path: 'planResult',
                query: { id: this.id },
              })
            } else {
              this.$vux.loading.hide()
              this.$vux.toast.text(data.Result.ErrorMsg, 'top')
            }
          })
          .catch(() => {
            this.$vux.loading.hide()
          })
      } else {
        this.$router.push('addPlan')
      }

      // this.$emit('changeClose')
    },
    goToHome() {
      this.$router.push('myPlan')
    },
    inPageFn() {
      // let timer = setTimeout(() => {
      //   this.loading = false
      //   clearTimeout(timer)
      // }, 3000)
    },
  },
  // watch: {
  //   score() {
  //     const score = this.score
  //     if (score <= 3) {
  //       this.tag = '谨慎型'
  //     } else if (score >= 4 && score <= 9) {
  //       this.tag = '稳健型'
  //     } else if (score >= 10 && score <= 12) {
  //       this.tag = '平衡型'
  //     } else if (score >= 13 && score <= 15) {
  //       this.tag = '进取型'
  //     } else if (score >= 16) {
  //       this.tag = '激进型'
  //     }
  //   },
  // },
}



// WEBPACK FOOTER //
// ./src/pages/components/testDialog.vue